var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17.063,
    viewBox: "0 0 17.5 17.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "message-icon",
    d: "M5.648,16.625l-3.9,3.063V3.5a.875.875,0,0,1,.875-.875h15.75a.875.875,0,0,1,.875.875V15.75a.875.875,0,0,1-.875.875Zm-.605-1.75H17.5V4.375H3.5V16.087ZM9.625,8.75h1.75V10.5H9.625Zm-3.5,0h1.75V10.5H6.125Zm7,0h1.75V10.5h-1.75Z",
    transform: "translate(-1.75 -2.625)",
    fill: "#948fb5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.f6ff5824b678db65820b5dc02d8b3389.svg";
export { ForwardRef as ReactComponent };